import { Impression, Interaction, PageImpressionEvent } from '../apis';

export type TrackingEventObserver = {
  onInteraction?: (interaction: Interaction) => void;
  onImpression?: (impression: Impression) => void;
  onPageImpression?: (event: PageImpressionEvent) => void;
};

const observers = new Set<TrackingEventObserver>();

export function subscribeToTrackingEvents(
  observer: TrackingEventObserver,
): () => void {
  observers.add(observer);
  return () => {
    observers.delete(observer);
  };
}

export function notifyInteraction(interaction: Interaction): void {
  for (const observer of observers) {
    observer.onInteraction?.(interaction);
  }
}

export function notifyImpression(impression: Impression): void {
  for (const observer of observers) {
    observer.onImpression?.(impression);
  }
}

export function notifyPageImpression(event: PageImpressionEvent): void {
  for (const observer of observers) {
    observer.onPageImpression?.(event);
  }
}
